import AppHeaderDescription, {
  AppHeaderDescriptionProps,
} from './AppHeaderDescription';

export default AppHeaderDescription;
export type { AppHeaderDescriptionProps };
